<script setup>
const items = ref([]);
import { onMounted, ref, watch } from "vue";
import { CheckIcon, SelectorIcon } from "@heroicons/vue/solid";
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxLabel,
    ComboboxOption,
    ComboboxOptions,
} from "@headlessui/vue";

const props = defineProps({ filter: Object });
const emit = defineEmits(["apply", "cancel"]);
const query = ref("");
const selectedItem = ref({ code: "", name: "Start typing to search" });
const filteredItem = ref([]);

watch(query, (value) => {
    if (value.length > 0) {
        fetchSectors(value);
    } else {
        filteredItem.value = [];
    }
});

const fetchSectors = (q) => {
    return axios.get(`/api/sectors?query=${q}`).then((response) => {
        filteredItem.value = response.data.data;
    });
};

watch(selectedItem, (value) => {
    if (value.code) {
        handleSubmit();
    }
});

const handleSubmit = () => {
    emit(
        "apply",
        Object.assign(props.filter, {
            value: selectedItem.value.name,
            code: selectedItem.value.code,
        })
    );
};

onMounted(() => {
    //selectedItem.value = items.filter((item) => item.code === "CA")[0];
});
</script>
<template>
    <Combobox
        as="div"
        class="w-1/2 bg-white rounded-lg px-[20px] py-[40px] border-[1px] border-gray-200"
        v-model="selectedItem"
    >
        <ComboboxLabel class="block text-sm font-medium text-gray-700"
            >Search sector by code or name
        </ComboboxLabel>
        <div class="relative mt-1">
            <ComboboxInput
                onfocus="this.value=''"
                class="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                @change="query = $event.target.value"
                :displayValue="(item) => item.name"
            />
            <ComboboxButton
                class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
            >
                <SelectorIcon
                    class="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                />
            </ComboboxButton>

            <ComboboxOptions
                v-if="filteredItem.length > 0"
                class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            >
                <ComboboxOption
                    v-for="item in filteredItem"
                    :key="item.code"
                    :value="item"
                    as="template"
                    v-slot="{ active, selected }"
                >
                    <li
                        :class="[
                            'relative cursor-default select-none py-2 pl-3 pr-9',
                            active
                                ? 'bg-indigo-600 text-white'
                                : 'text-gray-900',
                        ]"
                    >
                        <span
                            :class="[
                                'block truncate',
                                selected && 'font-semibold',
                            ]"
                        >
                            {{ item.name }}
                        </span>

                        <span
                            v-if="selected"
                            :class="[
                                'absolute inset-y-0 right-0 flex items-center pr-4',
                                active ? 'text-white' : 'text-indigo-600',
                            ]"
                        >
                            <CheckIcon class="h-5 w-5" aria-hidden="true" />
                        </span>
                    </li>
                </ComboboxOption>
            </ComboboxOptions>
        </div>
    </Combobox>
</template>
